"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _toUpper2 = _interopRequireDefault(require("lodash/toUpper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var StringUtil = /*#__PURE__*/function () {
  function StringUtil() {
    _classCallCheck(this, StringUtil);
  }

  _createClass(StringUtil, null, [{
    key: "isString",
    value: function isString(stringOrNumber) {
      return (0, _isString2.default)(stringOrNumber);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(value) {
      if ((0, _isString2.default)(value)) {
        return (0, _isEmpty2.default)(value);
      } else if (value === undefined) {
        return true;
      }

      return false;
    }
  }, {
    key: "isNotEmpty",
    value: function isNotEmpty(value) {
      return !(0, _isEmpty2.default)(value);
    }
  }, {
    key: "isAllEmpty",
    value: function isAllEmpty(values) {
      if (Array.isArray(values)) {
        var _iterator = _createForOfIteratorHelper(values),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var value = _step.value;

            if (!(0, _isEmpty2.default)(value)) {
              return false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return true;
      } else if (values === undefined) {
        return true;
      }

      return false;
    }
    /**
     * Whitespaces return empty
     * @param value
     * @returns {boolean}
     */

  }, {
    key: "isBlank",
    value: function isBlank(value) {
      if ((0, _isString2.default)(value)) {
        return (0, _isEmpty2.default)(value.trim());
      }

      return StringUtil.isEmpty(value);
    }
  }, {
    key: "isAllBlank",
    value: function isAllBlank(values) {
      if (Array.isArray(values)) {
        var _iterator2 = _createForOfIteratorHelper(values),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var value = _step2.value;

            if (!StringUtil.isBlank(value)) {
              return false;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return true;
      } else if (values === undefined) {
        return true;
      }

      return false;
    }
  }, {
    key: "isNoneBlank",
    value: function isNoneBlank(values) {
      if (Array.isArray(values)) {
        var _iterator3 = _createForOfIteratorHelper(values),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var value = _step3.value;

            if (StringUtil.isBlank(value)) {
              return false;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        return true;
      }

      return !StringUtil.isBlank(values);
    }
  }, {
    key: "toUpper",
    value: function toUpper(value) {
      return (0, _toUpper2.default)(value);
    }
    /**
     * Count multi-bytes characters
     * @param value
     */

  }, {
    key: "characterCount",
    value: function characterCount() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return Array.from(value).length;
    }
  }, {
    key: "subCharacter",
    value: function subCharacter() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var length = arguments.length > 2 ? arguments[2] : undefined;
      var chars = Array.from(value);
      return chars.slice(start, start + length).join('');
    }
  }]);

  return StringUtil;
}();

exports.default = StringUtil;